import React, { Component } from 'react';
import {Helmet} from 'react-helmet';

class Signup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      bdayMonth: 0,
      bdayDay: 0,
      anniversaryMonth: 0,
      anniversaryDay: 0,
      guestName1: '',
      a1BdayMonth: 0,
      a1BdayDay: 0,
      guestName2: '',
      a2BdayMonth: 0,
      a2BdayDay: 0,
      guestName3: '',
      a3BdayMonth: 0,
      a3BdayDay: 0,
      isCouponDiscount: false,
      isSpecialDiscount: false,
      isNewItemDiscount: false,
      isEventDiscount: false,
      isDisclaimerChecked: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {

    const name = event.target.name;
    const value = event.target.value;

    if (name === 'coupon-discount' || name === 'special-discount' || name === 'new-item-discount' || 
      name === 'event-discount' || name === 'disclaimer-check') {

      if (name === 'coupon-discount') {
        this.setState({
          isCouponDiscount: !this.state.isCouponDiscount
        }); 
      } else if (name === 'special-discount') {
        this.setState({
          isSpecialDiscount: !this.state.isSpecialDiscount
        }); 
      } else if (name === 'new-item-discount') {
        this.setState({
          isNewItemDiscount: !this.state.isNewItemDiscount
        }); 
      } else if (name === 'event-discount') {
        this.setState({
          isEventDiscount: !this.state.isEventDiscount
        }); 
      } else if (name === 'disclaimer-check') {
        this.setState({
          isDisclaimerChecked: !this.state.isDisclaimerChecked
        }); 
      }
    } else {
      this.setState({
        [name]: value
      });
    }
    
    if (name === 'bdayMonth' || name === 'anniversaryMonth' ||
      name === 'a1BdayMonth' || name === 'a2BdayMonth' || name === 'a3BdayMonth') {

      let dayTitle,
        maxDay = 0,
        select;

      if (name === 'bdayMonth') {
        dayTitle = 'B-Day*';
        select = document.getElementById('bdayDay');
      } else if (name === 'anniversaryMonth') {
        dayTitle = 'A-Day';
        select = document.getElementById('anniversaryDay');
      } else if (name === 'a1BdayMonth') {
        dayTitle = 'B-Day';
        select = document.getElementById('a1BdayDay');
      } else if (name === 'a2BdayMonth') {
        dayTitle = 'B-Day';
        select = document.getElementById('a2BdayDay');
      } else if (name === 'a3BdayMonth') {
        dayTitle = 'B-Day';
        select = document.getElementById('a3BdayDay');
      }
      
      if (value === 1 || value === 3 || value === 5 || value === 7 || value === 8 || value === 10 || value === 12) {
        maxDay = 31;
      } else if (value === 2) {
        maxDay = 29;
      } else if (value === 4 || value === 6 || value === 9 || value === 11) {
        maxDay = 30;
      }

      if (maxDay > 0) {

        // remove all days first
        select.options.length = 0;

        // add new days
        let opt = document.createElement('option');
        opt.value = 0;
        opt.innerHTML = dayTitle;
        select.appendChild(opt);
        for (let i = 1; i <= maxDay; i++) {
            opt = document.createElement('option');
            opt.value = i;
            opt.innerHTML = i;
            select.appendChild(opt);
        }      
      }
    }
  }

  handleSubmit = (event) => {

    console.log('Submitting form ' + JSON.stringify(this.state));

    if (this.state.firstName === '' || this.state.firstName.length === 0) {
      document.getElementById('firstName').style.border = '3px red solid';
    } else {
      document.getElementById('firstName').style.border = '1px #484c51 solid';
    }

    if (this.state.lastName === '' || this.state.lastName.length === 0) {
      document.getElementById('lastName').style.border = '3px red solid';
    } else {
      document.getElementById('lastName').style.border = '1px #484c51 solid';
    }

    if (this.state.email === '' || this.state.email.length === 0 ||
      !this.state.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      document.getElementById('email').style.border = '3px red solid';
    } else {
      document.getElementById('email').style.border = '1px #484c51 solid';
    }

    if (this.state.bdayMonth === 0) {
      document.getElementById('bdayMonth').style.border = '3px red solid';
    } else {
      document.getElementById('bdayMonth').style.border = '1px #484c51 solid';
    }

    if (this.state.bdayDay === 0) {
      document.getElementById('bdayDay').style.border = '3px red solid';
    } else {
      document.getElementById('bdayDay').style.border = '1px #484c51 solid';
    }

    if (this.state.isDisclaimerChecked === false) {
      document.getElementById('disclaimer').style.color = 'red';
    } else {
      document.getElementById('disclaimer').style.color = '#484c51';
    }

    event.preventDefault();
  }

  render() {
    return (
        <div className="page signup" id="page">
          <div className="heading">Signup</div>
          <div className="form">
            <div className="location-bar">
              <div className="location-info">
                <div className="location-name">Bhojanic</div>
                <div className="location-branch">Buckhead, GA</div>
              </div>
              <div className="location-logo">
                <img src="https://rewardeclub.imgix.net/location/0471d9ce-e4e1-51a8-ab38-b6df6ae0deed/logo/bhojanic-logo.jpeg?fit=crop&crop=edges&w=200&h=100&blend=000000" alt="Bhojanic" />
              </div>
            </div>
            <div className="required">* required</div>
            <form onSubmit={this.handleSubmit}>
              <label>
                <input type="text" name="firstName" id="firstName" placeholder="First Name*" value={this.state.firstName} onChange={this.handleChange} />
                <input type="text" name="lastName" id="lastName" placeholder="Last Name*" value={this.state.lastName} onChange={this.handleChange} />
                <input type="text" name="email" id="email" placeholder="Email*" value={this.state.email} onChange={this.handleChange} />

                <div className="bday-row">
                  <div className="bday-month">
                    <select name="bdayMonth" id="bdayMonth" value={this.change} onChange={this.handleChange}>
                      <option value="0">Birthday Month*</option>
                      <option value="1">January</option>
                      <option value="2">February</option>
                      <option value="3">March</option>
                      <option value="4">April</option>
                      <option value="5">May</option>
                      <option value="6">June</option>
                      <option value="7">July</option>
                      <option value="8">August</option>
                      <option value="9">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                  </div>
                  <div className="bday-day">
                    <select name="bdayDay" id="bdayDay" value={this.change} onChange={this.handleChange}>
                      <option value="0">B-Day*</option>
                    </select>
                  </div>
                </div>

                <div className="anniversary-row">
                  <div className="anniversary-month">
                    <select name="anniversaryMonth" id="anniversaryMonth" value={this.change} onChange={this.handleChange}>
                      <option value="0">Anniversary Month</option>
                      <option value="1">January</option>
                      <option value="2">February</option>
                      <option value="3">March</option>
                      <option value="4">April</option>
                      <option value="5">May</option>
                      <option value="6">June</option>
                      <option value="7">July</option>
                      <option value="8">August</option>
                      <option value="9">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                  </div>
                  <div className="anniversary-day">
                    <select name="anniversaryDay" id="anniversaryDay" value={this.change} onChange={this.handleChange}>
                      <option value="0">A-Day</option>
                    </select>
                  </div>
                </div>

                <div className="update-row">
                  <div className="update-heading">
                    Update me on the following:
                  </div>
                </div>
                <br />
                <div className="update-column-all">
                  <div className="update-column-row update-column-1">
                    <input type="checkbox" name="coupon-discount" checked={this.state.isCouponDiscount} onChange={this.handleChange} />
                    <label>Coupon Discount</label>
                  </div>
                  <div className="update-column-row update-column-2">
                    <input type="checkbox" name="special-discount" checked={this.state.isSpecialDiscount} onChange={this.handleChange} />
                    <label>Special Discount</label>
                  </div>
                  <div className="update-column-row update-column-3">
                    <input type="checkbox" name="new-item-discount" checked={this.state.isNewItemDiscount} onChange={this.handleChange} />
                    <label>New Item Discount</label>
                  </div>
                  <div className="update-column-row update-column-4">
                    <input type="checkbox" name="event-discount" checked={this.state.isEventDiscount} onChange={this.handleChange} />
                    <label>Upcoming Event Discount</label>
                  </div>
                </div>

                <div className="add-birthdays-row">
                  <div className="add-birthdays-heading">
                    Additional birthdays
                  </div>
                </div>
                <div className="add-birthdays-column-all">
                  <div className="add-birthdays-column-row">
                    <div className="add-birthdays-column-1">
                      <input type="text" name="guestName1" className="row-1" placeholder="Name" value={this.state.guestName1} onChange={this.handleChange} />
                    </div>
                    <div className="add-birthdays-column-2">
                      <div className="bday-month">
                        <select name="a1BdayMonth" id="a1BdayMonth" value={this.change} onChange={this.handleChange}>
                          <option value="0">Birthday Month*</option>
                          <option value="1">January</option>
                          <option value="2">February</option>
                          <option value="3">March</option>
                          <option value="4">April</option>
                          <option value="5">May</option>
                          <option value="6">June</option>
                          <option value="7">July</option>
                          <option value="8">August</option>
                          <option value="9">September</option>
                          <option value="10">October</option>
                          <option value="11">November</option>
                          <option value="12">December</option>
                        </select>
                      </div>
                      <div className="bday-day">
                        <select name="a1BdayDay" id="a1BdayDay" value={this.change} onChange={this.handleChange}>
                          <option value="0">B-Day</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="add-birthdays-column-row">
                    <div className="add-birthdays-column-1">
                      <input type="text" name="guestName2" className="row-1" placeholder="Name" value={this.state.guestName2} onChange={this.handleChange} />
                    </div>
                    <div className="add-birthdays-column-2">
                      <div className="bday-month">
                        <select name="a2BdayMonth" id="a2BdayMonth" value={this.change} onChange={this.handleChange}>
                          <option value="0">Birthday Month*</option>
                          <option value="1">January</option>
                          <option value="2">February</option>
                          <option value="3">March</option>
                          <option value="4">April</option>
                          <option value="5">May</option>
                          <option value="6">June</option>
                          <option value="7">July</option>
                          <option value="8">August</option>
                          <option value="9">September</option>
                          <option value="10">October</option>
                          <option value="11">November</option>
                          <option value="12">December</option>
                        </select>
                      </div>
                      <div className="bday-day">
                        <select name="a2BdayDay" id="a2BdayDay" value={this.change} onChange={this.handleChange}>
                          <option value="0">B-Day</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="add-birthdays-column-row">
                    <div className="add-birthdays-column-1">
                      <input type="text" name="guestName3" className="row-1" placeholder="Name" value={this.state.guestName3} onChange={this.handleChange} />
                    </div>
                    <div className="add-birthdays-column-2">
                      <div className="bday-month">
                        <select name="a3BdayMonth" id="a3BdayMonth" value={this.change} onChange={this.handleChange}>
                          <option value="0">Birthday Month*</option>
                          <option value="1">January</option>
                          <option value="2">February</option>
                          <option value="3">March</option>
                          <option value="4">April</option>
                          <option value="5">May</option>
                          <option value="6">June</option>
                          <option value="7">July</option>
                          <option value="8">August</option>
                          <option value="9">September</option>
                          <option value="10">October</option>
                          <option value="11">November</option>
                          <option value="12">December</option>
                        </select>
                      </div>
                      <div className="bday-day">
                        <select name="a3BdayDay" id="a3BdayDay" value={this.change} onChange={this.handleChange}>
                          <option value="0">B-Day</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <br />
                  <div className="disclaimer">
                    <div className="disclaimer-row-1">
                      <label>
                        Your info will never be shared with any third parties.
                      </label>
                    </div>
                    <div className="disclaimer-row-2" id="disclaimer">
                      <input type="checkbox" name="disclaimer-check" checked={this.state.isDisclaimerChecked} onChange={this.handleChange} />
                      <label>I am at least 14 years old.*</label>
                    </div>
                    <p/>
                  </div>

                </div>

              </label>
              <input type="submit" className="formSubmit" value="SUBMIT" />
            </form>
          </div>
        </div>
    );
  }
}

export default Signup;




// WEBPACK FOOTER //
// ./src/page/Signup.js